import clsx from 'clsx'

import { ButtonBack } from 'shared/ui/button-back'
import { Header } from 'shared/ui/header'

import s from './styles.module.scss'

interface Props {
  title?: string
  subtitle?: string
  actionRight?: React.ReactNode
  onGoBack: () => void
  onClickHeader?: () => void
}

export const KyrgyzstanHeader = ({
  title,
  subtitle,
  actionRight,
  onGoBack,
  onClickHeader,
}: Props) => (
  <div
    className={s.header}
    id="search-params-header"
  >
    <Header
      isFixed
      actionLeft={<ButtonBack onClick={onGoBack} />}
      actionRight={actionRight}
    >
      <div
        className={s.content}
        onClick={onClickHeader}
      >
        {title && <span className={clsx('bold-14', s.title)}>{title}</span>}
        {subtitle && (
          <span className={clsx('medium-12', s.subtitle)}>{subtitle}</span>
        )}
      </div>
    </Header>
  </div>
)
